import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/rv/upload.svg'


const _withScopeId = n => (_pushScopeId("data-v-a184a374"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-con" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Choose Payout Round", -1))
const _hoisted_3 = {
  key: 0,
  class: "error-tips"
}
const _hoisted_4 = { class: "download-con" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "font_family icon-xiazai" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Template Download ")
const _hoisted_7 = { class: "border-style" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-drag-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "uploadIcon"
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, [
  /*#__PURE__*/_createTextVNode(" Drag and drop to upload or "),
  /*#__PURE__*/_createElementVNode("span", { class: "blueFont" }, "browse for files")
], -1))
const _hoisted_11 = {
  key: 1,
  class: "process-con"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Selected Files: ")
const _hoisted_13 = { class: "margin-style" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "process-title-style" }, "Total Process:", -1))
const _hoisted_15 = { class: "process-style" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Complete")
const _hoisted_19 = { class: "size-style" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Upload")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Browse")
const _hoisted_22 = {
  key: 0,
  class: "no-calculator-wrapper"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_24 = { style: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      } }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Import")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Tips ")
const _hoisted_28 = { class: "modal-txt" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Download")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Tips ")
const _hoisted_32 = { class: "modal-txt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_CheckCircleOutlined = _resolveComponent("CheckCircleOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_ExclamationCircleOutlined = _resolveComponent("ExclamationCircleOutlined")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    title: _ctx.title,
    closable: true,
    visible: _ctx.modal,
    curRole: _ctx.curRole,
    width: "35.14%",
    class: "upload-drawer claim-drawer",
    onClose: _ctx.close,
    getContainer: _ctx.spinWrapper
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_a_select, {
          value: _ctx.roundVal,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roundVal) = $event)),
          placeholder: "Please Select",
          class: "sel-inp-size",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowErrorTips = _ctx.roundVal.trim() === '' ? true : false))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roundList, (item) => {
              return (_openBlock(), _createBlock(_component_a_select_option, {
                value: item.id,
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"]),
        (_ctx.isShowErrorTips)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "please choose payout round!"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_a_button, {
          type: "link",
          class: "blueFont",
          onClick: _ctx.downloadTemHandle
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isBeforeUpload)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_a_upload_dragger, {
                name: "file",
                listType: "picture-card",
                showUploadList: false,
                multiple: false,
                "before-upload": _ctx.beforeUpload,
                customRequest: _ctx.uploadRequest
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["before-upload", "customRequest"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isBeforeUpload)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("p", null, [
                _hoisted_12,
                _createElementVNode("strong", null, _toDisplayString(_ctx.curUploadFile.name), 1)
              ]),
              _createElementVNode("p", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, [
                  _createVNode(_component_a_progress, {
                    percent: _ctx.curPercent,
                    strokeColor: "#108ee9"
                  }, null, 8, ["percent"]),
                  (!_ctx.completeTips)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.curPercent) + "% done", 1))
                    : _createCommentVNode("", true),
                  (_ctx.completeTips)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                        _createVNode(_component_CheckCircleOutlined, { style: {"color":"#108ee9"} }),
                        _hoisted_18
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.uploadFileSize), 1)
                ])
              ]),
              (_ctx.isShowUploadBtn)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    class: "right-style",
                    type: "primary",
                    disabled: !_ctx.isClickAbled,
                    onClick: _ctx.uploadFile
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    class: "right-style",
                    type: "primary",
                    onClick: _ctx.showUploadHandle
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isShowTable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createVNode(_component_a_table, {
              style: {"margin-top":"10px"},
              rowKey: "id",
              dataSource: _ctx.dataSource,
              columns: _ctx.columns,
              pagination: false,
              scroll: {
          y: 200,
        }
            }, null, 8, ["dataSource", "columns"]),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.handleExport
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_a_button, {
          style: {"margin-right":"8px"},
          onClick: _ctx.close
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          type: "primary",
          disabled: !_ctx.isImport,
          onClick: _ctx.importFile
        }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _createVNode(_component_a_modal, {
        visible: _ctx.downloadModalVisible,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.downloadModalVisible) = $event)),
        "ok-button-props": { disabled: true },
        "cancel-button-props": { disabled: true },
        onOk: _ctx.handleDownload,
        centered: ""
      }, {
        title: _withCtx(() => [
          _createVNode(_component_ExclamationCircleOutlined, { style: {"color":"#faad14"} }),
          _hoisted_27
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            key: "back",
            onClick: _ctx.handleCancel
          }, {
            default: _withCtx(() => [
              _hoisted_29
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.showDownload)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: "submit",
                type: "primary",
                loading: _ctx.loading,
                onClick: _ctx.handleDownload
              }, {
                default: _withCtx(() => [
                  _hoisted_30
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.downloadTipsText), 1)
        ]),
        _: 1
      }, 8, ["visible", "onOk"]),
      _createVNode(_component_a_modal, {
        visible: _ctx.emptyVisible,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emptyVisible) = $event)),
        footer: null,
        centered: ""
      }, {
        title: _withCtx(() => [
          _createVNode(_component_ExclamationCircleOutlined, { style: {"color":"#faad14"} }),
          _hoisted_31
        ]),
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.emptyTipsText), 1)
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }, 8, ["title", "visible", "curRole", "onClose", "getContainer"]))
}